import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { InputGroup, Form, Col } from 'react-bootstrap';
import Label from '../Label';
import ErrorMessage from '../ErrorMessage';
import './styles.scss';

const TextArea = React.forwardRef(
  (
    {
      defaultValue = '',
      label = '',
      hasValidation = true,
      maxLength = 100,
      type = 'text',
      placeholder = 'Escribe aquí ...',
      labelClassName = '',
      className = '',
      onChange,
      containerClassName,
      mask,
      ...props
    },
    ref
  ) => {
    const [field, meta] = useField(props);
    const handleChange = (e) => {
      if (mask) {
        const { value } = e.target;

        const newValue =
          typeof mask === 'function'
            ? mask(value, false)
            : mask?.apply(value, false);

        e.target.value = newValue;
      }
      field.onChange(e);
      if (onChange) onChange(e);
    };

    const { error, touched } = meta;
    const fieldPlaceholder = placeholder || label;

    return (
      <InputGroup hasValidation={hasValidation} className="TextArea Input my-2">
        <Label label={label} className={labelClassName} />

        <Col xs={12} className={containerClassName}>
          <Form.Control
            {...props}
            {...field}
            ref={ref}
            as="textarea"
            type={type}
            onChange={handleChange}
            placeholder={fieldPlaceholder}
            maxLength={maxLength}
            isInvalid={touched && error}
            className={`TextArea__textarea ${className}`}
            defaultValue={defaultValue}
          />
        </Col>

        <ErrorMessage {...meta} className="text-right" />
      </InputGroup>
    );
  }
);

TextArea.propTypes = {
  defaultValue: PropTypes.string,
  label: PropTypes.string,
  hasValidation: PropTypes.bool,
  maxLength: PropTypes.number,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  labelClassName: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  containerClassName: PropTypes.string,
  mask: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      apply: PropTypes.func
    })
  ])
};

export default TextArea;
